import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@/components/addpage'),
        name: 'Dashboard',
        meta: { title: '首页', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/pages/login/index'),
    hidden: true
  }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  {
    path: '/sys',
    component: Layout,
    redirect: '/sys/page',
    alwaysShow: true, // will always show the root menu
    name: 'sys',
    meta: {
      title: '系统管理',
      icon: 'lock'
    },
    children: [
      {
        path: 'editpwd',
        component: () => import('@/pages/sys/editpwd'),
        name: 'editpwd',
        meta: {
          title: '密码修改',
          icon: 'lock'
        }
      }
    ]
  },
  {
    path: '/customer',
    component: Layout,
    redirect: '/customer/page',
    alwaysShow: true, // will always show the root menu
    name: 'customer',
    meta: {
      title: '注册管理',
      icon: 'lock'
    },
    children: [
      {
        path: 'manager',
        component: () => import('@/pages/customer/manager'),
        name: 'manager',
        meta: {
          title: '客户管理',
          icon: 'lock'
        }
      }
    ]
  },
  {
    path: '/accouct',
    component: Layout,
    redirect: '/accouct/page',
    alwaysShow: true, // will always show the root menu
    name: 'accouct',
    meta: {
      title: '账户管理',
      icon: 'lock'
    },
    children: [
      {
        path: 'addmoney',
        component: () => import('@/pages/accouct/addmoney'),
        name: 'addmoney',
        meta: {
          title: '账户充值',
          icon: 'lock'
        }
      },
      {
        path: 'changemoney',
        component: () => import('@/pages/accouct/changemoneydetail'),
        name: 'changemoney',
        meta: {
          title: '余额变动明细',
          icon: 'lock'
        }
      },
      {
        path: 'jlmoney',
        component: () => import('@/pages/accouct/jlmoneydetail'),
        name: 'jlmoney',
        meta: {
          title: '奖励金变动明细',
          icon: 'lock'
        }
      }
    ]
  },
  {
    path: '/market',
    component: Layout,
    redirect: '/market/page',
    alwaysShow: true, // will always show the root menu
    name: 'market',
    meta: {
      title: '营销推广',
      icon: 'lock'
    },
    children: [
      {
        path: 'qrcode',
        component: () => import('@/pages/market/qrcode'),
        name: 'qrcode',
        meta: {
          title: '专属二维码',
          icon: 'lock'
        }
      }
    ]
  }, /*,
  {
    path: '/settlement',
    component: Layout,
    redirect: '/settlement/page',
    alwaysShow: true, // will always show the root menu
    name: 'settlement',
    meta: {
      title: '结算管理',
      icon: 'lock'
    },
    children: [
      {
        path: 'order',
        component: () => import('@/pages/settlement/order'),
        name: 'order',
        meta: {
          title: '订单管理',
          icon: 'lock'
        }
      },
      {
        path: 'invbase',
        component: () => import('@/pages/settlement/invbase'),
        name: 'invbase',
        meta: {
          title: '开票信息',
          icon: 'lock'
        }
      },
      {
        path: 'invoice',
        component: () => import('@/pages/settlement/invoice'),
        name: 'invoice',
        meta: {
          title: '发票管理',
          icon: 'lock'
        }
      },
      {
        path: 'detail',
        component: () => import('@/pages/settlement/detail'),
        name: 'detail',
        meta: {
          title: '结算明细',
          icon: 'lock'
        }
      }
    ]
  } */
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js